import React from 'react';

export const OwnUpWhiteLogo = () => (
  <svg width="38" height="40" viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.71134 13.1157C0.264418 13.4464 0 13.9746 0 14.5368V25.9742C0 26.6923 0.800766 27.1071 1.3716 26.6848L19 13.642L36.6284 26.6848C37.1992 27.1071 38 26.6923 38 25.9742V14.5368C38 13.9746 37.7356 13.4464 37.2887 13.1157L20.0159 0.336089C19.4103 -0.112029 18.5897 -0.11203 17.9841 0.336088L0.71134 13.1157Z"
      fill="white"
    />
    <path
      d="M25.0455 32.0926V40H12.9545V32.0926C12.9545 28.6959 15.6612 25.9424 19 25.9424C22.3388 25.9424 25.0455 28.6959 25.0455 32.0926Z"
      fill="white"
    />
  </svg>
);
